import { render } from "./UserComponent.vue?vue&type=template&id=d4c97a6c&scoped=true"
import script from "./UserComponent.vue?vue&type=script&lang=js"
export * from "./UserComponent.vue?vue&type=script&lang=js"

import "./UserComponent.vue?vue&type=style&index=0&id=d4c97a6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dvdsa\\projects\\avante-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c97a6c"]])

export default __exports__